/**
 * @generated SignedSource<<d802bd9d06509932efbd64c106009e3a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SendTestParticipantInvitesInput = {
  clientMutationId?: string | null;
  emails: ReadonlyArray<string>;
  studyId: string;
};
export type ShareTestScreenerModal_sendTestParticipantInvites_Mutation$variables = {
  input: SendTestParticipantInvitesInput;
};
export type ShareTestScreenerModal_sendTestParticipantInvites_Mutation$data = {
  readonly sendTestParticipantInvites: {
    readonly response: {
      readonly sent: boolean | null;
    } | null;
  } | null;
};
export type ShareTestScreenerModal_sendTestParticipantInvites_Mutation = {
  response: ShareTestScreenerModal_sendTestParticipantInvites_Mutation$data;
  variables: ShareTestScreenerModal_sendTestParticipantInvites_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SendTestParticipantInvitesPayload",
    "kind": "LinkedField",
    "name": "sendTestParticipantInvites",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SendEmailResponse",
        "kind": "LinkedField",
        "name": "response",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sent",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ShareTestScreenerModal_sendTestParticipantInvites_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ShareTestScreenerModal_sendTestParticipantInvites_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2d9aa78a4de587f9cd1ad4b910bb6d7b",
    "id": null,
    "metadata": {},
    "name": "ShareTestScreenerModal_sendTestParticipantInvites_Mutation",
    "operationKind": "mutation",
    "text": "mutation ShareTestScreenerModal_sendTestParticipantInvites_Mutation(\n  $input: SendTestParticipantInvitesInput!\n) {\n  sendTestParticipantInvites(input: $input) {\n    response {\n      sent\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c38070ea8e99a81cd82d67921a584b9e";

export default node;
